export default {
  miniSidebarCommit(state, data) {
    state.miniSidebarMenu = data;
  },
  activePageCommit(state, data) {
    state.activePage = data;
  },
  setLangCommit(state, data) {
    state.lang = data;
  },
  setTimeZoneCommit(state, data) {
    state.timeZone = data;
  },
  setOrganizationCommit(state, data) {
    state.organization = data;
  },
  setUserCommit(state, data) {
    state.user = data;
  },
};
